export default "__VITE_ASSET__CCTR4Jrm__"